<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import InterviewCore from "@/views/Evaluation/EvaluationInterview/Components/InterviewCore.vue";

export default {
    components: {InterviewCore},
    setup() {
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const {loading, overlay} = useSharedData();

        const evaluationInterview = ref({
            note: 0,
            categories: [],
            questions: [],
            closed: false,
        });

        function findByUuid(uuid) {
            loading.value = true;
            axios.get(`/evaluationInterviews/uuid/${uuid}`).then((response) => {
                evaluationInterview.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save(validate) {
            loading.value = true;
            evaluationInterview.value.type = $route.params.type;
            evaluationInterview.value.closed = true;
            axios.post('/evaluationInterviews', evaluationInterview.value, {
                params: {
                    validate: validate,
                }
            }).then(() => {
                window.close();
                getBack();
            }).finally(() => {
                loading.value = false;
            });

        }

        onMounted(() => {
            findByUuid($route.params.uuid);
        });

        return {
            loading,
            overlay,
            evaluationInterview,
            save,
            getBack
        }
    }
}
</script>

<template>
    <v-app id="evaluate" style="background-color: #EEEEEE">
        <v-container>
            <v-row style="height: 100px;"></v-row>
            <v-row justify="center">
                <v-card>
                    <w-toolbar color="teal" title="Evaluation"/>
                    <w-overlay
                        :overlay="overlay"
                        :loading="loading"
                        apply-action
                        @apply="save(true)"
                        @cancel="overlay = false"
                    />
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-form ref="form">
                                <interview-core
                                    v-model="evaluationInterview"
                                    :type="$route.params.type"
                                />
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer/>
                        <w-btn-close :loading="loading" @press="getBack"/>
                        <w-btn
                            v-if="!evaluationInterview.closed"
                            icon="mdi-content-save-settings-outline"
                            color="red"
                            :text="'sauvegarder'"
                            :loading="loading"
                            @press="save(false)"
                        />
                        <w-btn-apply
                            :show="!evaluationInterview.closed"
                            :loading="loading"
                            @press="overlay = true"
                        />
                    </v-card-actions>
                </v-card>
            </v-row>
            <v-row style="height: 100px;"></v-row>
        </v-container>
    </v-app>
</template>